<template>
  <div class="content">
    <basic-panel v-if="bestPractice.fields.goal">
      <a slot="anchor" id='goal'></a>
      <h3 slot="title" class="title is-4 is-marginless">Cél</h3>
      <div slot="content"><markdown>{{ bestPractice.fields.goal }}</markdown></div>
    </basic-panel>

    <basic-panel v-if="bestPractice.fields.introduction">
      <a slot="anchor" id='introduction'></a>
      <h3 slot="title" class="title is-4 is-marginless">A témakör bemutatása</h3>
      <div slot="content"><markdown>{{ bestPractice.fields.introduction }}</markdown></div>
    </basic-panel>

    <basic-panel v-if="bestPractice.fields.resultsAndExpectations">
      <a slot="anchor" id='resultsAndExpectations'></a>
      <h3 slot="title" class="title is-4 is-marginless">Saját eredmények és várható eredmények a jógyakorlat alkalmazása által</h3>
      <div slot="content"><markdown>{{ bestPractice.fields.resultsAndExpectations }}</markdown></div>
    </basic-panel>

    <basic-panel v-if="bestPractice.fields.expectedImpact">
      <a slot="anchor" id='expectedImpact'></a>
      <h3 slot="title" class="title is-4 is-marginless">A jógyakorlat alkalmazásának várható gazdasági hatásai</h3>
      <div slot="content"><markdown>{{ bestPractice.fields.expectedImpact }}</markdown></div>
    </basic-panel>

    <basic-panel v-if="bestPractice.fields.flowCharts">
      <a slot="anchor" id='flowCharts'></a>
      <h3 slot="title" class="title is-4 is-marginless">Folyamatábrák</h3>
      <div slot="content"><markdown>{{ bestPractice.fields.flowCharts }}</markdown></div>
    </basic-panel>

    <basic-panel v-if="bestPractice.fields.fullDescription">
      <a slot="anchor" id='fullDescription'></a>
      <h3 slot="title" class="title is-4 is-marginless">A jógyakorlat leírása</h3>
      <div slot="content"><markdown>{{ bestPractice.fields.fullDescription }}</markdown></div>
    </basic-panel>

    <basic-panel v-if="bestPractice.fields.followUp">
      <a slot="anchor" id='followUp'></a>
      <h3 slot="title" class="title is-4 is-marginless">A jógyakorlat nyomon követése</h3>
      <div slot="content"><markdown>{{ bestPractice.fields.followUp }}</markdown></div>
    </basic-panel>

    <basic-panel v-if="bestPractice.fields.concepts">
      <a slot="anchor" id='concepts'></a>
      <h3 slot="title" class="title is-4 is-marginless">Kapcsolódó fogalmak</h3>
      <div slot="content" class="columns is-multiline">
        <div v-for="concept in bestPractice.fields.concepts"
             :key="concept.sys.id"
             class="column is-3-desktop is-4-tablet is-12-mobile">
          <router-link v-if="concept.fields" :to="{ name: 'glossary', query: { q: concept.fields.name } }"
                       class="concept is-fullwidth is-primary is-tooltip-info tooltip is-tooltip-multiline is-tooltip-bottom"
                       :data-tooltip="concept.fields.description">
            {{ concept.fields.name }}
          </router-link>
        </div>
      </div>
    </basic-panel>

    <basic-panel v-if="bestPractice.fields.glossaryItems">
      <a slot="anchor" id='glossaryItems'></a>
      <h3 slot="title" class="title is-4 is-marginless">Kapcsolódó rövidítések</h3>
      <div slot="content" class="columns is-multiline">
        <div v-for="glossaryItem in bestPractice.fields.glossaryItems"
             :key="glossaryItem.sys.id"
             class="column is-3-desktop is-4-tablet is-12-mobile">
          <router-link v-if="glossaryItem.fields" :to="{ name: 'glossary', query: { q: glossaryItem.fields.name } }"
                       class="glossary is-fullwidth is-primary is-tooltip-info tooltip is-tooltip-multiline is-tooltip-bottom"
                       :data-tooltip="glossaryItem.fields.description">
            <strong>{{ glossaryItem.fields.name }}</strong>
          </router-link>
        </div>
      </div>
    </basic-panel>

    <basic-panel v-if="bestPractice.fields.bibliography">
      <a slot="anchor" id='bibliography'></a>
      <h3 slot="title" class="title is-4 is-marginless">Irodalomjegyzék</h3>
      <div slot="content"><markdown>{{ bestPractice.fields.bibliography }}</markdown></div>
    </basic-panel>

    <basic-panel v-if="bestPractice.fields.additionalInformation">
      <a slot="anchor" id='additionalInformation'></a>
      <h3 slot="title" class="title is-4 is-marginless">Adalékok a jógyakorlat sikeres bevezetéséhez</h3>
      <div slot="content" v-for="additionalInformation in bestPractice.fields.additionalInformation"
           :key="additionalInformation.sys.id">
        <h4>{{ additionalInformation.fields.title }}</h4>
        <markdown>{{ additionalInformation.fields.description }}</markdown>
        <hr>
      </div>
    </basic-panel>

    <basic-panel v-if="bestPractice.fields.attachments">
      <a slot="anchor" id='attachments'></a>
      <h3 slot="title" class="title is-4 is-marginless">Csatolmányok</h3>
      <div slot="content">
        <div v-for="attachment in bestPractice.fields.attachments"
             :key="attachment.sys.id"
        >
          <a :href="attachment.fields.file.url">
            <div class="file has-name is-fullwidth">
              <label class="file-label">
                <span class="file-cta">
                  <span class="file-icon"><font-awesome-icon icon="download"></font-awesome-icon></span>
                  <span class="file-label">Megtekintés</span>
                </span>
                <span class="file-name">{{ attachment.fields.title }}</span>
              </label>
            </div>
          </a>
        </div>
      </div>
    </basic-panel>
  </div>
</template>

<script>
  import BasicPanel from '@/components/General/BasicPanel'

  export default {
    props: [
      'bestPractice'
    ],
    components: {
      BasicPanel
    }
  }
</script>

<style scoped>
  .column {
    display: flex;
  }
  .file {
    margin-bottom: 2px;
  }
  .glossary {
    margin: 15px 6.5px 15px 6.5px;
  }
  .concept {
    margin: 15px 6.5px 15px 6.5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/BestPractice/BestPracticeDetailed.vue